
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { CalendarUrlOption } from '@/types';

@Component
export default class CopyToClipboardIcon extends Vue {
  // Testo da copiare
  @Prop(String) readonly text!: string | null
  // Opzioni per l'export del calendario
  @Prop({ type: Array, default: () => [] }) readonly options!: CalendarUrlOption[]

  // Icona da utilizzare
  @Prop({ default: 'mdi-content-copy' }) readonly icon!: string

  // Testo da utilizzare come tooltip prima di copiare
  @Prop({ default: 'Copia negli appunti' }) readonly tooltip!: string

  // Testo da utilizzare come tooltip dopo aver copiato
  @Prop({ default: 'Copiato!' }) readonly tooltipCopied!: string

  success = false
  showTooltip = false

  get tooltipText(): string {
    return this.success ? this.tooltipCopied : this.tooltip;
  }

  onMouseOver() {
    // eslint-disable-next-line no-console
    console.log('onMouseOver');
    this.showTooltip = true;
  }

  onMouseOut() {
    // eslint-disable-next-line no-console
    console.log('onMouseOut');
    this.showTooltip = false;
  }

  async onClick(url: string | null) {
    console.log(`${this.constructor.name}: onClick(${url})`); // eslint-disable-line no-console

    try {
      // Se url è null, usa this.text come valore di default
      const textToCopy = url ?? this.text ?? '';
      console.log('textToCopy =', textToCopy); // eslint-disable-line no-console

      // Copia il testo negli appunti
      await navigator.clipboard.writeText(textToCopy);

      // Il resto del tuo codice...
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to copy text: ', err);
    }
  }
}
